import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  GeckoCardWrapper,
  GeckoCardHeader,
  GeckoCardBody,
  GeckoCardFooter,
  GeckoBtnsSorted,
  GeckoFields,
} from '../';

// Models
import { GeckoFieldsModel, GeckoBtnsModel } from '../../models';

class GeckoCardForm extends Component {
  renderHeader() {
    return (
      <GeckoCardHeader name={this.props.name} btns={this.props.headerBtns} />
    );
  }

  renderBody() {
    if (this.props.fields.length) {
      return (
        <GeckoFields
          fields={this.props.fields}
          values={this.props.values}
          submitHandler={this.props.submitHandler.bind(this)}
          handler={this.props.handler.bind(this)}
        />
      );
    }
    return null;
  }

  renderFooter() {
    if (this.props.footerBtns.length) {
      return (
        <GeckoCardFooter>
          <GeckoBtnsSorted items={this.props.footerBtns} />
        </GeckoCardFooter>
      );
    }
    return null;
  }

  render() {
    return (
      <GeckoCardWrapper>
        {this.renderHeader()}

        <GeckoCardBody padded>
          {this.renderBody()}

          <div>{this.props.children}</div>
        </GeckoCardBody>

        {this.renderFooter()}
      </GeckoCardWrapper>
    );
  }
}

GeckoCardForm.defaultProps = {
  headerBtns: [],
  footerBtns: [],
  fields: [],
  values: {},
  handler: () => {},
  submitHandler: () => {},
};

GeckoCardForm.propTypes = {
  name: PropTypes.string,
  headerBtns: GeckoBtnsModel,
  footerBtns: GeckoBtnsModel,
  fields: GeckoFieldsModel,
  values: PropTypes.object,
  handler: PropTypes.func,
  submitHandler: PropTypes.func,
};

export default GeckoCardForm;
